import React from "react";
import { Controls, IFormStyles, useFormStyles } from "../.";
import { FormGroup, FormGroupProps, FormGroupType } from "./formGroup";

interface FormIconPickerProps extends Omit<Controls.ControlIconPickerProps, "controlStyles"> {
    isLoading?: boolean | undefined;
    label?: string | undefined;
    groupType?: FormGroupType | undefined;
    iconColor?: string | undefined;
}

const ComponentProps = (props: FormIconPickerProps): Controls.ControlIconPickerProps => {
    const p = Object.assign({}, props) as any;
    delete p.isLoading;
    delete p.groupType;
    delete p.label;
    delete p.isOptional;
    delete p.tooltip;
    return p as Controls.ControlIconPickerProps;
};

const GroupProps = (props: FormIconPickerProps): FormGroupProps => {
    const groupProps: FormGroupProps = {
        controlStyles: props.controlStyles,
        isLoading: props.isLoading,
        disabled: props.disabled,
        groupType: props.groupType,

        label: props.label,
        isOptional: props.isOptional,
        tooltip: props.tooltip,
    };

    return groupProps;
}

export const FormIconPicker: React.FC<FormIconPickerProps> = (props) => {
    const styles: IFormStyles = useFormStyles();

    const { label, ...rest } = props;
    const groupProps = { ...GroupProps(props), label: undefined };

    return (
        <FormGroup {...groupProps}>
            {label && <Controls.ControlLabel style={{ padding: 0 }}>{label}</Controls.ControlLabel>}
            <Controls.ControlIconPicker
                {...ComponentProps(rest as any)}
                controlStyles={styles.control}
            />
        </FormGroup>
    );
};

